<template>
    <div class="header">
        <div class="nav table">
            <ul class="table-row">
                <li class="table-cell back-cell">
                    <slot name="left" v-if="left"></slot>
                    <a href="javascript:;" v-else style="visibility: hidden;">
                        &laquo;
                    </a>
                </li>
                <li class="table-cell logo">
                    <a>{{title}}</a>
                </li>
                <li class="table-cell back-cell">
                    <slot name="right" v-if="right"></slot>
                    <a href="javascript:;" v-else style="visibility: hidden;">
                        &raquo;
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['app', 'back', 'title', 'right', 'left']
};
</script>
